export default __webpack_public_path__ + "static/media/cLogo17.dad23161.jpeg";